import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["root"]
  static values = {
    itemId: String,
  }

  connect() {
    const detail = { itemId: this.itemIdValue }
    const event = new CustomEvent("imageDetailInit", { detail })
    window.dispatchEvent(event)
    this.rootTarget.scrollIntoView({ behavior: "smooth", block: "center" })
  }

  onKeyDown(event) {
    switch (event.key) {
      case "ArrowLeft":
        this.goToPreviousPhoto()
        break
      case "ArrowRight":
        this.goToNextPhoto()
        break
    }
  }

  collapsePanel(event) {
    event.target.closest("turbo-frame").textContent = ""
  }

  closeFromInitEvent(event) {
    if (this.itemIdValue === event.detail.itemId) return
    this.rootTarget.closest("turbo-frame").textContent = ""
  }

  goToPreviousPhoto() {
    this.rootTarget.closest("[class^='item-']").previousElementSibling.querySelector("a").click()
  }

  goToNextPhoto() {
    this.rootTarget.closest("[class^='item-']").nextElementSibling.querySelector("a").click()
  }
}
